import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

export default function NoAccessComponent() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="text-center p-8 bg-white rounded-xl shadow-lg max-w-sm w-full transform transition-all duration-300 hover:scale-105 border-t-4 border-yellow-500">
        <ExclamationTriangleIcon className="h-16 w-16 text-yellow-500 mx-auto mb-4 animate-pulse" />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Lo siento, no tienes acceso
        </h1>
        <p className="text-gray-600">
          Por favor, contacta con el administrador para solicitar acceso a este apartado.
        </p>
      </div>
    </div>
  );
}